import React from 'react'
import { Main } from './components/Main'
import { Header } from './components/Header'
import { Route, Routes } from 'react-router-dom'
import { Footer } from './components/Footer'

export const App = () => {
  return (
    <>
      <Header/>
      <Routes>
        <Route path='/' element={<Main/>}/>
      </Routes>
      <Footer/>
    </>
  )
}

